/*
 * Planner Messages
 *
 * This contains all the text for the Planner component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.Planner.Students.EditModal.header',
    defaultMessage: 'Edit meeting {name}',
  },
  meeting: {
    id: 'app.components.Planner.Students.EditModal.meeting',
    defaultMessage: 'Meeting',
  },
  intro: {
    id: 'app.components.Planner.Students.EditModal.intro',
    defaultMessage: 'Select which parents can schedule the meeting. These parents will receive the invitation to schedule a meeting.',
  },
  extra: {
    id: 'app.components.Planner.Students.EditModal.extra',
    defaultMessage: 'Plan an additional meeting (e.g., for divorced parents)',
  },
});
